import { BaseLink } from '../../navigation/HeaderRedesignBaseLink';
import styled from 'styled-components';

export const DesktopMenuContainer = styled.div`
  display: flex;
  flex-direction: row;

  font-family: 'Basis Grt', sans-serif;
  font-weight: 400;
  color: #203437;
`;

export const DesktopMenuLinks = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.5; /* 200% as wide as blue promo card */

  padding: 2.75rem 2.5rem 2rem 2.5rem;
`;

export const DesktopMenuTitle = styled.div`
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.0375rem;
  color: #1c4259;
  text-transform: uppercase;
`;

export const DesktopMenuLink = styled(BaseLink)`
  font-family: 'Basis Grt', sans-serif;
  color: #203437;
  font-weight: 400;
`;

export const DesktopMenuColumns = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3.75rem;
  min-height: 6.5rem;
`;
